var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("integrations.title")))]),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("integrations.exact")))])]
          ),
          _vm._v(" "),
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              type: "info",
              title: _vm.$t("integrations.exact_division_info"),
              closable: false,
              "show-icon": ""
            }
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "connectExactForm",
              attrs: {
                model: _vm.exact.form,
                "label-width": "200px",
                disabled: !_vm.hasPermission
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.custom_app") } },
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.exact.form.custom,
                      callback: function($$v) {
                        _vm.$set(_vm.exact.form, "custom", $$v)
                      },
                      expression: "exact.form.custom"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.exact.form.custom
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("integrations.client_id") } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "" },
                          model: {
                            value: _vm.exact.form.clientId,
                            callback: function($$v) {
                              _vm.$set(_vm.exact.form, "clientId", $$v)
                            },
                            expression: "exact.form.clientId"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("integrations.client_secret") }
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "", type: "password" },
                          model: {
                            value: _vm.exact.form.clientSecret,
                            callback: function($$v) {
                              _vm.$set(_vm.exact.form, "clientSecret", $$v)
                            },
                            expression: "exact.form.clientSecret"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("integrations.webhook_secret") }
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "", type: "password" },
                          model: {
                            value: _vm.exact.form.webhookSecret,
                            callback: function($$v) {
                              _vm.$set(_vm.exact.form, "webhookSecret", $$v)
                            },
                            expression: "exact.form.webhookSecret"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("integrations.redirect_uri") } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "" },
                          model: {
                            value: _vm.exact.form.redirectUri,
                            callback: function($$v) {
                              _vm.$set(_vm.exact.form, "redirectUri", $$v)
                            },
                            expression: "exact.form.redirectUri"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.participant.name") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "", disabled: true },
                    model: {
                      value: _vm.participantName,
                      callback: function($$v) {
                        _vm.participantName = $$v
                      },
                      expression: "participantName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("legalEntity") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { clearable: "", size: "mini" },
                      model: {
                        value: _vm.exact.form.legalEntity,
                        callback: function($$v) {
                          _vm.$set(_vm.exact.form, "legalEntity", $$v)
                        },
                        expression: "exact.form.legalEntity"
                      }
                    },
                    _vm._l(_vm.localLegalEntities, function(legalEntity) {
                      return _c(
                        "el-option",
                        {
                          key: legalEntity.reference,
                          attrs: {
                            value: legalEntity.reference,
                            label: legalEntity.registration_name
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(legalEntity.registration_name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled:
                          _vm.exact.loading ||
                          (_vm.exact.form.legalEntity === null ||
                            _vm.exact.form.legalEntity === "") ||
                          !_vm.hasPermission
                      },
                      on: { click: _vm.connectExact }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("integrations.connect_exact")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("integrations.ponto")))])]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "connectPontoForm",
              attrs: {
                model: _vm.ponto.form,
                "label-width": "200px",
                disabled: !_vm.hasPermission
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.participant.name") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "", disabled: true },
                    model: {
                      value: _vm.participantName,
                      callback: function($$v) {
                        _vm.participantName = $$v
                      },
                      expression: "participantName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("legalEntity") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { clearable: "", size: "mini" },
                      model: {
                        value: _vm.ponto.form.legalEntity,
                        callback: function($$v) {
                          _vm.$set(_vm.ponto.form, "legalEntity", $$v)
                        },
                        expression: "ponto.form.legalEntity"
                      }
                    },
                    _vm._l(_vm.localLegalEntities, function(legalEntity) {
                      return _c(
                        "el-option",
                        {
                          key: legalEntity.reference,
                          attrs: {
                            value: legalEntity.reference,
                            label: legalEntity.registration_name
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(legalEntity.registration_name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled:
                          _vm.ponto.loading ||
                          (_vm.ponto.form.legalEntity === null ||
                            _vm.ponto.form.legalEntity === "")
                      },
                      on: { click: _vm.connectPonto }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("integrations.connect_ponto")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("integrations.teamleader")))])]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "connectTeamleaderForm",
              attrs: {
                model: _vm.teamleader.form,
                "label-width": "200px",
                disabled: !_vm.hasPermission
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.participant.name") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "", disabled: true },
                    model: {
                      value: _vm.participantName,
                      callback: function($$v) {
                        _vm.participantName = $$v
                      },
                      expression: "participantName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("legalEntity") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { clearable: "", size: "mini" },
                      model: {
                        value: _vm.teamleader.form.legalEntity,
                        callback: function($$v) {
                          _vm.$set(_vm.teamleader.form, "legalEntity", $$v)
                        },
                        expression: "teamleader.form.legalEntity"
                      }
                    },
                    _vm._l(_vm.localLegalEntities, function(legalEntity) {
                      return _c(
                        "el-option",
                        {
                          key: legalEntity.reference,
                          attrs: {
                            value: legalEntity.reference,
                            label: legalEntity.registration_name
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(legalEntity.registration_name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled:
                          _vm.teamleader.loading ||
                          (_vm.teamleader.form.legalEntity === null ||
                            _vm.teamleader.form.legalEntity === "")
                      },
                      on: { click: _vm.connectTeamleader }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("integrations.connect_teamleader")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("integrations.octopus")))])]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "connectOctopusForm",
              attrs: {
                model: _vm.octopus.form,
                "label-width": "200px",
                disabled: !_vm.hasPermission
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.participant.name") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "", disabled: true },
                    model: {
                      value: _vm.participantName,
                      callback: function($$v) {
                        _vm.participantName = $$v
                      },
                      expression: "participantName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("legalEntity") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { clearable: "", size: "mini" },
                      model: {
                        value: _vm.octopus.form.legalEntity,
                        callback: function($$v) {
                          _vm.$set(_vm.octopus.form, "legalEntity", $$v)
                        },
                        expression: "octopus.form.legalEntity"
                      }
                    },
                    _vm._l(_vm.localLegalEntities, function(legalEntity) {
                      return _c(
                        "el-option",
                        {
                          key: legalEntity.reference,
                          attrs: {
                            value: legalEntity.reference,
                            label: legalEntity.registration_name
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(legalEntity.registration_name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled:
                          _vm.octopus.loading ||
                          (_vm.octopus.form.legalEntity === null ||
                            _vm.octopus.form.legalEntity === "")
                      },
                      on: { click: _vm.connectOctopus }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("integrations.connect_octopus")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("integrations.gdw")))])]
          ),
          _vm._v(" "),
          !_vm.hasGdwGetTokenPermission
            ? _c("el-alert", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  type: "warning",
                  title: _vm.$t("notAllowed"),
                  closable: false,
                  "show-icon": ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "connectGdwForm",
              attrs: {
                model: _vm.gdw.form,
                "label-width": "200px",
                disabled: !_vm.hasGdwGetTokenPermission
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.participant.name") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "mini", disabled: "" },
                    model: {
                      value: _vm.participantName,
                      callback: function($$v) {
                        _vm.participantName = $$v
                      },
                      expression: "participantName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("legalEntity") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        size: "mini",
                        loading: _vm.gdw.loadingCredentials
                      },
                      model: {
                        value: _vm.gdw.form.legalEntity,
                        callback: function($$v) {
                          _vm.$set(_vm.gdw.form, "legalEntity", $$v)
                        },
                        expression: "gdw.form.legalEntity"
                      }
                    },
                    _vm._l(_vm.filteredGdwLegalEntities, function(le) {
                      return _c(
                        "el-option",
                        {
                          key: le.reference,
                          attrs: {
                            value: le.reference,
                            label: le.registration_name
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(le.registration_name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.party_id") } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "100px" },
                      attrs: {
                        placeholder: "",
                        maxlength: "6",
                        size: "mini",
                        disabled: _vm.gdw.loadingCredentials
                      },
                      model: {
                        value: _vm.gdw.form.partyId,
                        callback: function($$v) {
                          _vm.$set(_vm.gdw.form, "partyId", $$v)
                        },
                        expression: "gdw.form.partyId"
                      }
                    },
                    [
                      _vm.gdw.loadingCredentials
                        ? _c("i", {
                            staticClass: "el-input__icon el-icon-loading",
                            attrs: { slot: "suffix" },
                            slot: "suffix"
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.token") } },
                [
                  _c(
                    "el-input",
                    {
                      class: {
                        "is-error": _vm.gdw.form.token && !_vm.isGdwTokenValid
                      },
                      staticStyle: { width: "400px" },
                      attrs: {
                        placeholder: "",
                        maxlength: "60",
                        size: "mini",
                        type: _vm.gdw.showToken ? "text" : "password",
                        disabled: _vm.gdw.loadingCredentials
                      },
                      model: {
                        value: _vm.gdw.form.token,
                        callback: function($$v) {
                          _vm.$set(_vm.gdw.form, "token", $$v)
                        },
                        expression: "gdw.form.token"
                      }
                    },
                    [
                      _vm.gdw.loadingCredentials
                        ? _c("i", {
                            staticClass: "el-input__icon el-icon-loading",
                            attrs: { slot: "prefix" },
                            slot: "prefix"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            icon: _vm.gdw.showToken
                              ? "el-icon-close"
                              : "el-icon-view",
                            disabled: _vm.gdw.loadingCredentials
                          },
                          on: {
                            click: function($event) {
                              _vm.gdw.showToken = !_vm.gdw.showToken
                            }
                          },
                          slot: "append"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.gdw.showToken
                                  ? _vm.$t("integrations.hide_token")
                                  : _vm.$t("integrations.show_token")
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.gdw.form.token && !_vm.isGdwTokenValid
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#F56C6C",
                            "font-size": "12px",
                            "line-height": "1",
                            "padding-top": "4px"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("integrations.token_format_error")
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#909399",
                            "font-size": "12px",
                            "line-height": "1",
                            "padding-top": "4px"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("integrations.token_format_hint")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                ],
                1
              ),
              _vm._v(" "),
              _vm.gdw.status
                ? _c(
                    "el-form-item",
                    [
                      _c("el-alert", {
                        attrs: {
                          type: _vm.gdw.status.type,
                          title: _vm.gdw.status.message,
                          closable: true,
                          "show-icon": ""
                        },
                        on: {
                          close: function($event) {
                            _vm.gdw.status = null
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: !_vm.hasGdwSaveTokenPermission
                          ? _vm.$t("notAllowed")
                          : "",
                        placement: "top",
                        disabled: _vm.hasGdwSaveTokenPermission
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            disabled:
                              _vm.gdw.loading ||
                              !_vm.hasGdwSaveTokenPermission ||
                              !_vm.gdw.form.legalEntity ||
                              !_vm.gdw.form.partyId ||
                              !_vm.isGdwTokenValid
                          },
                          on: { click: _vm.saveGdw }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("integrations.save_gdw")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("integrations.twikey")))])]
          ),
          _vm._v(" "),
          !_vm.hasTwikeyGetApiKeyPermission
            ? _c("el-alert", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  type: "warning",
                  title: _vm.$t("notAllowed"),
                  closable: false,
                  "show-icon": ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "connectTwikeyForm",
              attrs: {
                model: _vm.twikey.form,
                "label-width": "200px",
                disabled: !_vm.hasTwikeyGetApiKeyPermission
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.participant.name") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "mini", disabled: "" },
                    model: {
                      value: _vm.participantName,
                      callback: function($$v) {
                        _vm.participantName = $$v
                      },
                      expression: "participantName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("legalEntity") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        size: "mini",
                        loading: _vm.twikey.loadingCredentials
                      },
                      model: {
                        value: _vm.twikey.form.legalEntity,
                        callback: function($$v) {
                          _vm.$set(_vm.twikey.form, "legalEntity", $$v)
                        },
                        expression: "twikey.form.legalEntity"
                      }
                    },
                    _vm._l(_vm.filteredTwikeyLegalEntities, function(le) {
                      return _c(
                        "el-option",
                        {
                          key: le.reference,
                          attrs: {
                            value: le.reference,
                            label: le.registration_name
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(le.registration_name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.api_url") } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "400px" },
                      attrs: {
                        placeholder: "",
                        size: "mini",
                        disabled: _vm.twikey.loadingCredentials
                      },
                      model: {
                        value: _vm.twikey.form.apiUrl,
                        callback: function($$v) {
                          _vm.$set(_vm.twikey.form, "apiUrl", $$v)
                        },
                        expression: "twikey.form.apiUrl"
                      }
                    },
                    [
                      _vm.twikey.loadingCredentials
                        ? _c("i", {
                            staticClass: "el-input__icon el-icon-loading",
                            attrs: { slot: "suffix" },
                            slot: "suffix"
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.twikey.form.apiUrl && !_vm.isTwikeyApiUrlValid
                    ? _c(
                        "div",
                        {
                          staticClass: "el-form-item__error",
                          staticStyle: {
                            position: "static",
                            "margin-top": "4px"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("integrations.invalid_twikey_api_url")
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("integrations.api_key") } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "400px" },
                      attrs: {
                        placeholder: "",
                        size: "mini",
                        type: _vm.twikey.showApiKey ? "text" : "password",
                        disabled: _vm.twikey.loadingCredentials
                      },
                      model: {
                        value: _vm.twikey.form.apiKey,
                        callback: function($$v) {
                          _vm.$set(_vm.twikey.form, "apiKey", $$v)
                        },
                        expression: "twikey.form.apiKey"
                      }
                    },
                    [
                      _vm.twikey.loadingCredentials
                        ? _c("i", {
                            staticClass: "el-input__icon el-icon-loading",
                            attrs: { slot: "prefix" },
                            slot: "prefix"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            icon: _vm.twikey.showApiKey
                              ? "el-icon-close"
                              : "el-icon-view",
                            disabled: _vm.twikey.loadingCredentials
                          },
                          on: {
                            click: function($event) {
                              _vm.twikey.showApiKey = !_vm.twikey.showApiKey
                            }
                          },
                          slot: "append"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.twikey.showApiKey
                                  ? _vm.$t("integrations.hide_api_key")
                                  : _vm.$t("integrations.show_api_key")
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.twikey.status
                ? _c(
                    "el-form-item",
                    [
                      _c("el-alert", {
                        attrs: {
                          type: _vm.twikey.status.type,
                          title: _vm.twikey.status.message,
                          closable: true,
                          "show-icon": ""
                        },
                        on: {
                          close: function($event) {
                            _vm.twikey.status = null
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: !_vm.hasTwikeySaveApiKeyPermission
                          ? _vm.$t("notAllowed")
                          : "",
                        placement: "top",
                        disabled: _vm.hasTwikeySaveApiKeyPermission
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            disabled:
                              _vm.twikey.loading ||
                              !_vm.hasTwikeySaveApiKeyPermission ||
                              !_vm.twikey.form.legalEntity ||
                              !_vm.twikey.form.apiUrl ||
                              !_vm.twikey.form.apiKey ||
                              !_vm.isTwikeyApiUrlValid
                          },
                          on: { click: _vm.saveTwikey }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("integrations.save_twikey")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }